import _ from "underscore";

import {ItemGroup} from "../groups/itemGroup";
import {NoGroup} from "../groups/noGroup";
import {Questionary} from "../questionary";
import {Form} from "../form/form";
import Cell from "../form/cell";
import {ContentTypeFactory, ContentType, ValidateResult} from "../contentType";
import {XmlTagInfo} from "../xmlTagProvider";
import {QuestionaryVariable} from "../questionary";
import Grid from "../form/grid";
import {Vnode} from "mithril";

// abstract cell item
export abstract class CellItem {

    // after init form, cell and questionary must be defined
	questionary!: Questionary;
	form!: Form; // todo
	cell!: Cell; // todo
	childrenTags: XmlTagInfo[];

	group?: ItemGroup<CellItem>;

	variable: QuestionaryVariable<any>|null = null;
	variableName: string;

	protected contentType?: ContentType;
	private config: any;
	private groupName: string;

	constructor(config:XmlTagInfo) {
		this.config = config;
		this.variableName = config.attributes['variable'];
		this.childrenTags = config.children;
		this.groupName = this.config.attributes['group'];
	}

	init(questionary: Questionary, form: Form, cell: Cell){

		this.questionary = questionary;
		this.form = form;
		this.cell = cell;

		// try {
		var contentTypes = this.childrenTags
			.filter(node => node.tag === 'contentType')
			.map(node => ContentTypeFactory.create(node.attributes, questionary.messages));

		this.contentType = ContentTypeFactory.fromArray(contentTypes);


		if(this.variableName){
			this.variable = this.questionary.variableByName(this.variableName);
		}
	}

	initGroup(grid: Grid) {
		this.group = grid.groupById(this.groupName) || new NoGroup(grid.form);
		this.group.add(this); // todo: move out?
	}
	abstract getView(): Vnode|null;

	// should return true if we can proceed to next question
	// cell is considered valid if all items inside are valid
	validate () : ValidateResult{
		return ValidateResult.okResult();
	}

	// should be true only if item represents selected answer (checked checkbox, selected radio ... )
	// cell is considered active if any item inside is active
	active(): boolean {
		return false;
	}

	// should return true if component is without value (used for global unknown to determine whether it can stay true)
	isEmpty (){
		if(this.variable !== null){
			const value = this.variable();
			return value == null || value === 0 || value === "";
		}
		return true;
	}

	isVisible() {
		return true;
	}

	// default reset method, should be overridden by controls
	// reset variable - set default value
	reset (){
		this.unset();
	}

	// unset variable - used eg. by events. Acts like variable was never filled
	unset() {
		if(this.variable){
			this.variable(undefined);
		}
	}

	blockNext (){
		return false;
	}

	resourcesToPreload(): string[] {
		return [];
	}

	getSimpleContentResources(tags: XmlTagInfo[]){
		const resources: any[] = [];

		const images = _(tags).filter(t => t.tag === 'image');
		_(images).each(i => {
			resources.push(i.attributes['normal']);
			if(i.attributes['selected']){
				resources.push(i.attributes['selected']);
			}
			if(i.attributes['dropped']){
				resources.push(i.attributes['dropped']);
			}
		});

		return _(resources).map(r => this.questionary!.getFileUrl(r));
	}

	onNext (){ /* do nothing */ }

	onNavigatedTo (){ /* do nothing */ }

	globalKeyPressed (e: KeyboardEvent){ /* do nothing */ }

	// TODO refactor to TextCell class
	protected textValueFilled(value?: string|null): boolean {
		return ! _.isUndefined(value) && value !== null && value !== "";
	}

	/**
	 * Get variable value
	 */
	public getVariable():any|null {
	    if (this.variable === null) {
	        return null;
        }
	    return this.variable();
    }

	/**
	 * Set variable value
	 */
    public setVariable(value:any):void {
        if (this.variable !== null) {
            this.variable(value);
        }
    }

    protected updateUnknowns (){
        if (this.getVariable()) { // Jsem právě zašktrtlý
            this.form.activeGlobalUnknown = null; // vyřadím aktivní globalUnknown (uživatel právě někam zadal nějaké known údaje)
            this.form.resetGlobalUnknown(); // a vyresetuji všechna GU ve formuláři
        }

        this.group!.updateLocalUnknown(this);
    }

    public get label(): string|undefined {
	    return this.childrenTags.filter(t => t.tag==='text')[0]?.value
    }

}